export enum PageType {
    Product = 'product',
    Wishlist = 'wishlist',
    Cart = 'cart',
}
